<template lang="pug">
v-scale-transition(hide-on-leave)
  v-avatar.mx-1(:color='color' size='8' style={ opacity: `.8`} v-if='show' :title='$t("modified")')
</template>

<script>
export default {
  name: 'ModifiedDot',
  props: {
    show: {
      default: true,
    },
    color: {
      default: 'white',
    },
  },
}
</script>

<style scoped lang="sass">
</style>

<i18n src="@/lang/components/modifiedDot.json"></i18n>
